var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLevel1 = function SvgLevel1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.969 9.969 1 21 1s20 8.969 20 20-8.969 20-20 20S1 32.031 1 21Z",
    fill: "url(#Level_1_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 21c0 11.028-8.928 20-20 20C9.972 41 1 32.072 1 21 1 9.972 9.928 1 21 1c11.028 0 20 8.972 20 20Z",
    stroke: "url(#Level_1_svg__b)",
    strokeWidth: 0.806,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.556 21c0 10.24-8.315 18.556-18.512 18.556-10.24 0-18.556-8.315-18.556-18.556 0-10.24 8.315-18.556 18.556-18.556C31.24 2.444 39.556 10.76 39.556 21Z",
    fill: "url(#Level_1_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.289 21c0-8.709 7.046-15.755 15.755-15.755S36.799 12.291 36.799 21s-7.046 15.755-15.755 15.755c-8.71 0-15.755-7.046-15.755-15.755Z",
    fill: "url(#Level_1_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.449 21c0 8.534-6.915 15.405-15.405 15.405C12.51 36.405 5.639 29.49 5.639 21c0-8.534 6.915-15.405 15.405-15.405 8.49 0 15.405 6.871 15.405 15.405Z",
    stroke: "url(#Level_1_svg__e)",
    strokeWidth: 0.517,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.779 21c0 7.046-5.733 12.78-12.779 12.78S8.221 28.045 8.221 21c0-7.046 5.733-12.779 12.779-12.779s12.779 5.733 12.779 12.78Z",
    fill: "url(#Level_1_svg__f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.295 21c0-8.14 6.609-14.705 14.705-14.705 8.14 0 14.705 6.609 14.705 14.705 0 8.14-6.609 14.705-14.705 14.705A14.68 14.68 0 0 1 6.295 21Z",
    fill: "url(#Level_1_svg__g)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Level_1_svg__i",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 30,
    height: 30
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.295 21c0-8.14 6.609-14.705 14.705-14.705 8.14 0 14.705 6.609 14.705 14.705 0 8.14-6.609 14.705-14.705 14.705A14.68 14.68 0 0 1 6.295 21Z",
    fill: "url(#Level_1_svg__h)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Level_1_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.247 34.129c1.4-10.416 9.366-18.95 17.55-25.208-3.633-3.02-8.534-4.332-13.392-3.063C8.352 7.958 3.582 16.36 5.727 24.632c1.269 4.946 2.231 7.703 6.52 9.497Z",
    fill: "url(#Level_1_svg__j)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.061 27.565a.812.812 0 0 1-.087-.307l-.044-.13s-.35-.045-.438-.045c.088-.043.175-.131.263-.175l.087-.087-.043-.132c-.044-.087-.044-.218-.088-.306.088.044.394.219.394.219l.131-.088c.088-.043.175-.13.263-.175-.044.088-.044.22-.088.307l-.043.131.087.087c.088.088.175.176.263.22h-.482l-.043.13c-.044.132-.088.263-.132.35Z",
    fill: "url(#Level_1_svg__k)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.742 31.635v-.438s-.307-.131-.394-.175c.087-.044.175-.088.306-.131l.131-.044v-.438c.088.088.307.35.307.35l.131-.044c.088-.043.219-.043.307-.087-.044.087-.088.175-.175.306l-.088.132.087.13c.044.088.132.176.176.307-.132-.044-.22-.044-.35-.087l-.132-.044-.087.087a.954.954 0 0 0-.22.176Z",
    fill: "url(#Level_1_svg__l)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.372 34.96c.044-.087.044-.218.088-.305l.043-.132s-.262-.219-.35-.262c.088 0 .22 0 .307-.044h.13l.045-.131c.043-.088.043-.175.087-.307.044.088.219.394.219.394h.438l-.22.219-.087.087.044.132c.044.131.088.219.088.35-.088-.044-.22-.131-.307-.175l-.131-.044-.088.088c-.13 0-.218.087-.306.13Z",
    fill: "url(#Level_1_svg__m)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m28.002 37.411-.262-.262-.088-.087-.131.043a.81.81 0 0 1-.306.088.917.917 0 0 1 .175-.263l.043-.131s-.218-.263-.262-.35c.087 0 .219.044.306.044h.131l.088-.132c.044-.087.131-.175.175-.262 0 .087.088.437.088.437l.13.044c.088.044.22.044.307.088a2.507 2.507 0 0 0-.306.175l-.131.043v.132c.043.175.043.306.043.393Z",
    fill: "url(#Level_1_svg__n)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.363 38.724c-.043-.087-.131-.218-.175-.306l-.043-.131h-.482c.088-.088.131-.175.219-.219l.087-.087s-.13-.307-.13-.438l.262.131.131.044.088-.088a.527.527 0 0 0 .218-.218c0 .087-.043.437-.043.437l.13.088c.088.044.176.131.264.175-.088.044-.22.044-.307.087l-.131.044-.044.131c0 .132-.044.22-.044.35Z",
    fill: "url(#Level_1_svg__o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.506 38.68c-.044-.13-.044-.218-.088-.35l-.044-.13-.131-.045c-.088-.043-.219-.043-.306-.087.087-.044.175-.088.262-.175l.131-.088s-.043-.35-.043-.437c.087.087.175.131.219.218l.087.088.131-.044.263-.131a8.938 8.938 0 0 0-.175.438l.087.087c.088.088.132.175.22.219h-.482l-.044.131c.044.132-.044.22-.087.307Z",
    fill: "url(#Level_1_svg__p)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.823 37.368v-.482l-.131-.043a2.5 2.5 0 0 1-.307-.175c.088-.044.22-.044.307-.088l.13-.044s.088-.35.088-.437c.044.087.132.175.175.262l.088.132h.131c.088 0 .22-.044.307-.044a3.56 3.56 0 0 1-.263.35l.044.131c.043.088.087.175.175.306a.813.813 0 0 0-.306-.087l-.132-.044-.087.088c-.044 0-.132.087-.22.175Z",
    fill: "url(#Level_1_svg__q)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.497 34.83c-.088-.044-.175-.132-.263-.176l-.087-.087-.132.044c-.087.043-.218.13-.306.175.044-.132.088-.22.088-.35l.043-.132-.087-.087-.22-.22h.439s.175-.306.218-.393c.044.087.044.175.088.306l.044.132h.131c.088 0 .219.043.306.043-.087.088-.35.263-.35.263l.044.131c0 .175.044.263.044.35Z",
    fill: "url(#Level_1_svg__r)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17 31.503c-.087-.087-.13-.175-.218-.262l-.088-.088-.13.044c-.132.044-.22.044-.351.087.044-.087.131-.218.175-.306l.088-.088-.044-.13a2.512 2.512 0 0 0-.175-.307c.087.044.219.044.306.087l.131.044s.22-.262.307-.306v.437l.131.044c.088.044.175.088.306.131-.087.044-.394.176-.394.176v.13c0 .088 0 .176-.043.307Z",
    fill: "url(#Level_1_svg__s)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.895 27.39c-.044-.088-.087-.22-.131-.307l-.044-.131h-.481c.087-.088.175-.175.262-.219l.088-.087-.044-.132c-.044-.087-.044-.218-.088-.306.088.044.176.131.263.175l.131.088s.307-.175.394-.22c-.044.088-.044.22-.087.307l-.044.131.087.088c.088.044.175.131.263.175-.088 0-.438.044-.438.044l-.043.131c-.044.044-.044.175-.088.263Z",
    fill: "url(#Level_1_svg__t)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.801 22.794c0-.087-.044-.218-.044-.306v-.131l-.131-.044c-.131-.044-.219-.087-.35-.131.087-.044.219-.088.306-.131l.131-.044v-.482c.088.088.132.175.22.263l.087.087s.35-.087.437-.13l-.13.262-.045.131.088.088c.044.087.131.175.175.262-.088 0-.438-.044-.438-.044l-.087.088c-.132.087-.175.175-.219.262Z",
    fill: "url(#Level_1_svg__u)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.976 18.068c0-.131.044-.219.044-.306v-.132l-.088-.087c-.087-.044-.175-.131-.306-.219.131 0 .219-.044.35-.044l.131-.044.044-.13c.044-.088.044-.22.088-.307.043.087.087.175.13.306l.045.131h.437l-.218.22-.088.087.044.131c.043.088.087.175.131.306-.088-.043-.394-.175-.394-.175l-.087.088c-.132.044-.175.131-.263.175Z",
    fill: "url(#Level_1_svg__v)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m5.814 13.429-.131.044c-.088.043-.175.087-.307.13.044-.087.088-.218.132-.306l.043-.13-.087-.088c-.088-.088-.131-.175-.219-.263.131 0 .219 0 .35.044h.132l.087-.088c.044-.087.131-.175.175-.262 0 .087.044.219.044.306l.044.131s.35.088.437.132l-.262.131-.132.087v.132c0 .087 0 .219.044.306a8.425 8.425 0 0 0-.35-.306Z",
    fill: "url(#Level_1_svg__w)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44 9.578h-.131c-.088 0-.22.044-.307.044.088-.088.131-.175.219-.263l.088-.087-.044-.132c-.044-.087-.088-.219-.131-.306.13.044.218.087.306.131l.131.044.088-.088c.087-.087.175-.13.262-.218 0 .087-.044.218-.044.306v.131s.307.175.394.22c-.087.043-.219.043-.306.087l-.131.043-.044.132c0 .087-.044.219-.044.306-.087-.044-.306-.35-.306-.35Z",
    fill: "url(#Level_1_svg__x)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.028 6.645h-.13c-.088 0-.22-.043-.307-.043.087-.088.175-.132.262-.22l.088-.087v-.13c0-.132-.044-.22-.044-.351.088.087.175.131.263.219l.087.087.132-.043c.087-.044.218-.088.306-.132-.044.088-.088.22-.131.307l-.044.13s.219.263.306.307h-.437l-.044.132-.132.262c-.087-.131-.175-.438-.175-.438Z",
    fill: "url(#Level_1_svg__y)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m16.23 4.72-.131-.044c-.088-.043-.22-.087-.307-.13.088-.045.219-.088.307-.132l.13-.044V4.24c0-.131.045-.219.045-.35.087.087.13.175.218.262l.088.088.131-.044c.088 0 .219-.044.306-.044a.914.914 0 0 0-.174.263l-.088.087s.175.307.219.394c-.088-.044-.175-.044-.307-.087l-.13-.044-.088.087-.22.22c.045 0 0-.35 0-.35Z",
    fill: "url(#Level_1_svg__z)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.482 4.501c-.088-.044-.176-.131-.263-.175l-.131-.087-.132.087c-.087.044-.175.131-.262.175 0-.087.087-.437.087-.437l-.087-.088c-.088-.087-.175-.131-.263-.219.131 0 .219 0 .35-.043h.132l.043-.132c.044-.087.088-.219.132-.306.043.087.087.219.13.306l.045.132h.13c.088 0 .22.043.351.043a1.158 1.158 0 0 0-.262.22l-.088.087s.044.306.088.437Z",
    fill: "url(#Level_1_svg__A)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.639 4.895s-.35.087-.438.131c.044-.087.22-.394.22-.394s-.22-.262-.263-.35l.437.088.088-.088c.087-.087.131-.175.219-.262 0 .13.043.218.043.35v.13l.438.176c-.087.044-.219.088-.306.131l-.132.044s-.043.35-.043.438c-.044-.132-.263-.394-.263-.394Z",
    fill: "url(#Level_1_svg__B)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m30.015 7.127-.13-.263-.045-.13h-.437l.306-.307-.044-.131c-.043-.088-.087-.22-.131-.307.088.044.219.088.306.132l.132.043.087-.087c.088-.088.175-.132.263-.22 0 .132-.044.22-.044.351l-.044.131.088.088c.087.044.175.131.262.219-.087 0-.218.043-.306.043h-.131c.043.044-.088.35-.132.438Z",
    fill: "url(#Level_1_svg__C)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.429 10.103c0-.088-.044-.219-.044-.307l-.044-.13-.13-.045c-.088-.043-.22-.043-.307-.087.087-.044.394-.219.394-.219v-.131c0-.088 0-.219-.044-.307.087.088.175.132.263.22l.087.087.131-.044c.088-.044.22-.088.307-.131-.044.087-.088.219-.132.306l-.043.131.087.088c.088.087.131.175.219.262-.088 0-.219-.043-.306-.043h-.132c-.043 0-.218.262-.306.35Z",
    fill: "url(#Level_1_svg__D)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.967 13.867c0-.088.044-.219.044-.307v-.13l-.131-.088a.916.916 0 0 1-.263-.175c.088-.044.438-.132.438-.132l.044-.131c0-.088.043-.219.043-.306.044.087.132.175.175.262l.088.132h.131c.131 0 .219 0 .35-.044-.087.087-.131.175-.219.262l-.087.088.044.131c.043.088.087.219.131.306a2.138 2.138 0 0 0-.306-.13l-.132-.045s-.306.22-.35.307Z",
    fill: "url(#Level_1_svg__E)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38.112 18.287c-.088-.088-.175-.132-.263-.22l-.087-.087s-.307.131-.394.175c.043-.087.087-.175.131-.306l.044-.131-.088-.088-.219-.219h.438l.044-.131c.043-.088.087-.175.131-.306a.812.812 0 0 1 .088.306l.043.131.132.044c.131 0 .218.044.35.044a.705.705 0 0 1-.307.175l-.087.087v.132c0 .175.044.262.044.393Z",
    fill: "url(#Level_1_svg__F)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.243 22.97c-.044-.088-.131-.176-.175-.263l-.088-.088s-.35.044-.437.044c.044-.087.131-.175.175-.263l.087-.087-.044-.131-.13-.263c.087.044.437.131.437.131l.087-.087c.088-.088.132-.175.22-.263v.482l.13.043c.088.044.22.088.307.175-.131.044-.219.088-.35.088l-.132.044v.131c-.087.087-.087.219-.087.306Z",
    fill: "url(#Level_1_svg__G)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.195 30.002h-4.902v-9.453c0-1.138.044-2.189.088-3.151-.306.35-.657.744-1.138 1.137l-2.013 1.663-2.495-3.063 6.127-4.989h4.333v17.856Z",
    fill: "url(#Level_1_svg__H)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__a",
    x1: 1,
    y1: 21,
    x2: 41,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#BD8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#E0BE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DC83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__b",
    x1: 0.812,
    y1: 21,
    x2: 41.188,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#D4AA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__c",
    x1: 32.11,
    y1: 33.21,
    x2: 10.473,
    y2: 9.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#2B2C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#2B2C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__d",
    x1: 5.289,
    y1: 21,
    x2: 36.799,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#BD8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#E0BE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DC83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__e",
    x1: 5.489,
    y1: 21,
    x2: 36.599,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__f",
    x1: 11.244,
    y1: 12.88,
    x2: 30.539,
    y2: 28.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__g",
    x1: 6.293,
    y1: 21,
    x2: 35.722,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__h",
    x1: 6.293,
    y1: 21,
    x2: 35.722,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__k",
    x1: 36.495,
    y1: 26.949,
    x2: 37.722,
    y2: 26.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__l",
    x1: 34.35,
    y1: 31.019,
    x2: 35.533,
    y2: 31.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__m",
    x1: 31.156,
    y1: 34.367,
    x2: 32.383,
    y2: 34.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__n",
    x1: 27.173,
    y1: 36.752,
    x2: 28.4,
    y2: 36.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__o",
    x1: 22.666,
    y1: 38.065,
    x2: 23.893,
    y2: 38.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__p",
    x1: 17.939,
    y1: 38.021,
    x2: 19.122,
    y2: 38.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__q",
    x1: 13.388,
    y1: 36.73,
    x2: 14.615,
    y2: 36.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__r",
    x1: 9.536,
    y1: 34.214,
    x2: 10.763,
    y2: 34.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__s",
    x1: 6.385,
    y1: 30.887,
    x2: 7.612,
    y2: 30.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__t",
    x1: 4.241,
    y1: 26.796,
    x2: 5.468,
    y2: 26.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__u",
    x1: 3.278,
    y1: 22.157,
    x2: 4.549,
    y2: 22.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__v",
    x1: 3.628,
    y1: 17.43,
    x2: 4.855,
    y2: 17.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__w",
    x1: 5.248,
    y1: 13.119,
    x2: 6.519,
    y2: 13.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__x",
    x1: 8.005,
    y1: 9.312,
    x2: 9.276,
    y2: 9.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__y",
    x1: 11.593,
    y1: 6.445,
    x2: 12.82,
    y2: 6.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__z",
    x1: 15.795,
    y1: 4.477,
    x2: 17.022,
    y2: 4.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__A",
    x1: 20.434,
    y1: 3.886,
    x2: 21.748,
    y2: 3.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__B",
    x1: 25.16,
    y1: 4.651,
    x2: 26.387,
    y2: 4.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__C",
    x1: 29.405,
    y1: 6.489,
    x2: 30.588,
    y2: 6.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__D",
    x1: 32.906,
    y1: 9.487,
    x2: 34.177,
    y2: 9.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__E",
    x1: 35.62,
    y1: 13.229,
    x2: 36.891,
    y2: 13.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__F",
    x1: 37.239,
    y1: 17.627,
    x2: 38.466,
    y2: 17.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__G",
    x1: 37.545,
    y1: 22.332,
    x2: 38.816,
    y2: 22.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DEB95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Level_1_svg__H",
    x1: 26.399,
    y1: 31.713,
    x2: 0.772,
    y2: 11.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#D4AA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#AD7515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#FFFFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#DEB95F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Level_1_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-14.635 95.066 -127.715) scale(30.9559 31.7654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};
export default SvgLevel1;